import { Container } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  style?: React.CSSProperties;
}

export const PageContainer = ({ style, children }: Props) => {
  return (
    <Container
      sx={{
        ...style,
        p: 1,
        pt: 2,
        paddingBottom: "60px",
        maxWidth: "1500px !important",
      }}
    >
      {children}
    </Container>
  );
};
